import { Component } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-square',
  templateUrl: './square.component.html',
  styleUrls: ['./square.component.css'],
})
export class SquareComponent {
  url: string = 'square';
  payments: Array<any> = [];
  disputes: Array<any> = [];
  refunds: Array<any> = [];
  customers: Array<any> = [];
  payouts: Array<any> = [];
  bankAccounts: Array<any> = [];
  step = 1;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Merchant',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Banks',
      route: '/numbers/finance/plaid',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'Analysis',
      route: '/numbers/finance/analysis',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(`${this.url}`).subscribe((response) => {
      console.log('response data', response);

      if (response.rst) {
        this.payments = response.payments;
        this.payouts = response.payouts;
        this.refunds = response.refunds;
        this.disputes = response.disputes;
        this.customers = response.customers;
        this.bankAccounts = response.bankAccounts;
      }
    });
  }

  changeStep(step: number) {
    this.step = step;
  }

  getCustomerName(id: string): string {
    const cust = this.customers.find((p) => p.id === id);
    console.log('cust', cust);
    return cust ? cust.name + '(' + cust.email + ')' : 'Unknown';
  }
}
